import fontStyles from './fontStyles';
import resetStyles from './resetStyles';
const baseStyles = {
    '@global': {
        ...fontStyles,
        ...resetStyles,
    }
};
export default baseStyles;
//# sourceMappingURL=baseStyles.js.map